import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import DeliveryChargeTemplateList from "../pages/Template/TemplateList";
import EditDeliveryChargeTemplate from "../pages/Template/EditTemplate";
import DeliveryChargeList from "../pages/DeliveryCharge/DeliveryChargeList";
import CreateDeliveryCharge from "../pages/DeliveryCharge/CreateDeliveryCharge";
//@ts-ignore
import {
  PermissionRequired,
  AccessControl,
  //@ts-ignore
} from "@careinfo/permission-required";
import CreateTemplate from "../pages/Template/CreateTemplate";
import BranchChargeList from "../pages/BranchCharge/BranchChargeList";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<DeliveryChargeTemplateList />} />
          <Route
            path="/delivery-charge-template/:id"
            element={<DeliveryChargeTemplateList />}
          />
          <Route
            path="/create"
            element={
              <AccessControl
                children={<CreateTemplate />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                children={<EditDeliveryChargeTemplate />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/delivery-charge/:id"
            element={
              <AccessControl
                children={<DeliveryChargeList />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/branch-charge/:id"
            element={
              <AccessControl
                children={<BranchChargeList />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/delivery-charge/create"
            element={<CreateDeliveryCharge />}
          />
          <Route
            path="/delivery-charge/edit/:id"
            element={<EditDeliveryChargeTemplate />}
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
